import { useCallback } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import Radio from '@mui/material/Radio';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setContextUser } from 'features/views/userContext/actions';
import { getRoutePath } from 'utils/routeHelper';
import { joinString } from 'utils/string';

export const MyTeamTableRow = ({ seller, onClick, selectedSeller }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const selected = selectedSeller?.login === seller?.login;

	const handleRedirect = useCallback(
		(path) => (event) => {
			event.preventDefault();
			event.stopPropagation();

			const { pathname, state } = getRoutePath(path, {}, true);
			dispatch(setContextUser(seller));

			switch (path) {
				case 'tasks':
					navigate(
						{
							pathname,
							search: '?quickFilter=tasks',
						},
						{ state },
					);
					break;
				case 'marketPlace':
					navigate(pathname, { state });
					break;
				case 'contacts':
					navigate(
						{
							pathname,
							search: '?contactState=605&prefillToSeller=true',
						},
						{ state },
					);
					break;
			}
		},
		[dispatch, navigate, seller],
	);

	return (
		<TableRow onClick={onClick(seller)}>
			<TableCell>
				<FormControlLabel control={<Radio size="small" checked={selected} />} />
			</TableCell>
			<TableCell>{joinString(' ', [seller?.surname, seller?.firstName])}</TableCell>
			<TableCell>
				<Link underline="none" onClick={handleRedirect('tasks')}>
					{joinString('/', [seller?.taskCountSummary, seller?.taskCountAfterDeadlineActNoInfo])}
				</Link>
			</TableCell>
			<TableCell>
				<Link underline="none" onClick={handleRedirect('marketPlace')}>
					{joinString('/', [seller?.leadCountSummary, seller?.leadCountAssigned])}
				</Link>
			</TableCell>
			<TableCell>
				<Link underline="none" onClick={handleRedirect('contacts')}>
					{joinString('/', [seller?.campaignCountSummary, seller?.campaignCountAssigned])}
				</Link>
			</TableCell>
		</TableRow>
	);
};

MyTeamTableRow.propTypes = {
	onClick: PropTypes.func,
	selectedSeller: PropTypes.any,
	seller: PropTypes.object,
};

export default MyTeamTableRow;
